import { NIBUTCOLORS } from "./consts";
// import { debug } from 'webpack'
class NibutMapDraw {
  constructor(canvas, circlecnt, data, reportdata, color) {
    if (canvas) {
      this._canvas = canvas;
    } else {
      this._canvas = document.createElement("canvas");
    }
    this._ctx = this._canvas.getContext("2d");
    this.colorBar = [
      "white",
      "#ff0000",
      "#ff2000",
      "#ff4000",
      "#ff6000",
      "#ff8000",
      "#ffa000",
      "#ffc000",
      "#ffff00",
      "#dfff00",
      "#bfff00",
      "#bfff00",
      "#9fff00",
      "#7fff00",
      "#5fff00",
      "#3fff00",
      "#1fff00",
      "#00ff00"
    ];
    // 你传入的环数
    this._circlecnt = circlecnt;
    this.data = data || this.createMockdata();
    if (reportdata && reportdata.size) {
      this._canvas.width = reportdata.width;
      this._canvas.height = reportdata.height;
    }
    this._size = {
      width: this._canvas.width,
      height: this._canvas.height
    };
    this._padding = {
      left: 4,
      top: 20,
      right: 20,
      bottom: 20
    };
    this._color = color;
    this._realDiameter = 8;
    this._circleRect = this._calcCircleRect();
    this._circle = this._calcCircle();
    this._scale = (this._circle.r * 2) / this._realDiameter;
    this._ctx.strokeStyle = "white";
    this._ctx.fillStyle = "white";
    this._ctx.save("clear");
    this.clear();
    if (color === "white") {
      // var imageData = this._ctx.getImageData(0, 0, this._size.width, this._size.height)
      // for (var i = 0; i < imageData.data.length; i += 4) {
      // // 当该像素是透明的,则设置成白色
      //   if (imageData.data[i + 3] === 0) {
      //     imageData.data[i] = 255
      //     imageData.data[i + 1] = 255
      //     imageData.data[i + 2] = 255
      //     imageData.data[i + 3] = 255
      //   }
      // }
      // this._ctx.putImageData(imageData, 0, 0)

      this.DrawColorBar(190, -130, reportdata.usefultime);
    } else {
      // this._drawXYAxis()

      if (reportdata.usefultime !== undefined) {
        let result =
          typeof reportdata.usefultime === "string"
            ? parseFloat(reportdata.usefultime)
            : reportdata.usefultime;
        this.DrawColorBar(140, -130, result.toFixed(2));
      }
    }
    this._drawCircle();
    this._drawData(reportdata);
    this._drawCicleTick();
  }
  createMockdata() {
    let dataMock = [];
    for (let id = 0; id < 25; id++) {
      let data1 = [];
      for (let ix = 0; ix < 16; ix++) {
        let val = Math.random(Math.random()) * 20;
        data1.push(val);
      }
      dataMock.push(data1);
    }
    return dataMock;
  }
  testCenter(color) {
    let c = color || "white";
    this._ctx.beginPath();
    this._ctx.strokeStyle = c;
    this._ctx.moveTo(0, -this._circleRect.width);
    this._ctx.lineTo(0, this._circleRect.width);
    this._ctx.stroke();
    this._ctx.beginPath();
    this._ctx.moveTo(-this._circleRect.width, 0);
    this._ctx.lineTo(this._circleRect.width, 0);
    this._ctx.stroke();
  }
  clear() {
    this._ctx.restore("clear");
    this._ctx.clearRect(0, 0, this._size.width, this._size.height);
    this._ctx.save("clear");
    this._translate();
  }
  _translate() {
    this._ctx.translate(this._circleRect.center.x, this._circleRect.center.y);
  }

  _calcCircleRect() {
    let width = this._size.width > this._size.height ? this._size.height : this._size.width;
    return {
      width: width,
      center: {
        x:
          this._color === "white"
            ? (this._size.width - width) / 2.0 + width / 2 - 50
            : (this._size.width - width) / 2.0 + width / 2,
        y: (this._size.height - width) / 2.0 + width / 2
      }
    };
  }
  _calcCircle() {
    return {
      r: this._circleRect.width / 2 - 2 * this._padding.left,
      center: {
        x: this._circleRect.center.x,
        y: this._circleRect.center.y
      }
    };
  }
  /**
   * 绘制大圆
   */
  _drawCircle() {
    this._ctx.save("translate");
    this._ctx.translate(28, 0);
    this._ctx.beginPath();
    this._ctx.arc(-70, 0, this._circle.r, 0, Math.PI * 2);
    this._ctx.fillStyle = "white";
    this._ctx.fill();
    this._ctx.stroke();
    this._ctx.restore("translate");
  }
  _measureText(str) {
    let w = this._ctx.measureText(str || "X").width;
    let h = this._ctx.measureText("Z").width;
    return {
      width: w,
      height: h
    };
  }
  _dataInMap(v, isY = false) {
    return isY ? -1 * v * this._scale : v * this._scale;
  }
  _drawXYAxis() {
    this._ctx.save("translate");
    let scaleSize = 5;
    let size = this._measureText("0");
    let w = size.width;
    let h = size.height;
    let offset = 15;
    let xAxisTop = this._circle.r + 5 + offset;
    this._ctx.beginPath();
    this._ctx.moveTo(-this._circle.r + 28, this._circle.r + 25);
    this._ctx.lineTo(this._circle.r + 28, this._circle.r + 25);
    this._ctx.stroke();
    this._ctx.font = "20px Arial";
    this._ctx.beginPath();
    this._ctx.moveTo(0 + 28, xAxisTop + scaleSize);
    this._ctx.lineTo(0 + 28, xAxisTop + scaleSize * 2);
    this._ctx.fillText("0", 0 - w / 2 + 26, xAxisTop + scaleSize + h * 2 + 13);
    this._ctx.stroke();

    for (let id = 1; id <= this._realDiameter / 2; id++) {
      this._ctx.beginPath();
      this._ctx.moveTo(this._dataInMap(id) + 28, xAxisTop + scaleSize);
      this._ctx.lineTo(this._dataInMap(id) + 28, xAxisTop + scaleSize * 2);
      let text = id.toString();
      w = this._measureText(text).width;
      this._ctx.fillText(text, this._dataInMap(id) - w / 2 + 28, xAxisTop + scaleSize + h * 2 + 13);
      this._ctx.stroke();
      this._ctx.beginPath();
      this._ctx.moveTo(this._dataInMap(id, true) + 28, xAxisTop + scaleSize);
      this._ctx.lineTo(this._dataInMap(id, true) + 28, xAxisTop + scaleSize * 2);
      this._ctx.fillText(
        text,
        this._dataInMap(id, true) - w / 2 + 26,
        xAxisTop + scaleSize + h * 2 + 13
      );
      this._ctx.stroke();
    }
    // y坐标
    this._ctx.beginPath();
    this._ctx.moveTo(-this._circle.r - 25 + 20, this._circle.r);
    this._ctx.lineTo(-this._circle.r - 25 + 20, -this._circle.r);
    this._ctx.stroke();
    // y轴的刻度
    this._ctx.beginPath();
    this._ctx.moveTo(-this._circle.r - 25 + 20, 0);
    this._ctx.lineTo(-this._circle.r - 35 + 20, 0);
    this._ctx.stroke();
    // 0刻度
    this._ctx.font = "20px Arial";
    this._ctx.beginPath();
    this._ctx.moveTo(-this._circle.r - 25 + 20, 0);
    this._ctx.lineTo(-this._circle.r - 25 + 20, 0);
    this._ctx.fillText("0", -this._circle.r - 60 + h * 2 - 2 + 20, 0 - w / 2 + 14);
    this._ctx.stroke();
    // 整数刻度
    for (let id = 1; id <= this._realDiameter / 2; id++) {
      this._ctx.beginPath();
      this._ctx.moveTo(-this._circle.r - 25 + 20, this._dataInMap(id));
      this._ctx.lineTo(-this._circle.r - 32 + 20, this._dataInMap(id));
      let text = id.toString();
      w = this._measureText(text).width;
      this._ctx.fillText(
        text,
        -this._circle.r - 60 + h * 2 - 2 + 20,
        this._dataInMap(id) - w / 2 + 12
      );
      this._ctx.stroke();
      this._ctx.beginPath();
      this._ctx.moveTo(-this._circle.r - 25 + 20, this._dataInMap(id, true));
      this._ctx.lineTo(-this._circle.r - 32 + 20, this._dataInMap(id, true));
      this._ctx.fillText(
        text,
        -this._circle.r - 60 + h * 2 - 2 + 20,
        this._dataInMap(id, true) - w / 2 + 12
      );
      this._ctx.stroke();
    }
    this._ctx.restore("translate");
  }
  _getColor(v, usefultime) {
    let index = parseInt(v / 1.5);
    // console.log(index)
    // 数值为-1或者大于usefultime的时候颜色为#fff
    if (v === -1 || v > usefultime) {
      return "#fff";
    } else {
      return NIBUTCOLORS[index];
    }
  }
  // 画数据部分
  _drawData(usefultime) {
    this._ctx.save("translate");
    this._ctx.translate(28, 0);
    let rsplit = (4 / this._circlecnt) * this._scale;
    this._ctx.lineWidth = rsplit;
    for (let ix = this.data.length - 1; ix >= 0; ix--) {
      for (let iy = this.data[ix].length - 1; iy >= 0; iy--) {
        let color = this._getColor(this.data[ix][iy], usefultime);
        // console.log(this.data[ix][iy])
        this._ctx.fillStyle = color;
        this._ctx.beginPath();
        this._ctx.moveTo(-70, 0);
        this._ctx.arc(
          -70,
          0,
          (ix + 1) * rsplit,
          ((22.5 * iy) / 180) * Math.PI,
          ((22.5 * (iy + 1)) / 180) * Math.PI,
          false
        );
        this._ctx.fill();
      }
    }
    // 当中黑色小圆
    // this._ctx.beginPath()
    // this._ctx.arc(-70, 0, rsplit, 0, Math.PI * 2)
    // this._ctx.fillStyle = 'black'
    // this._ctx.fill()
    this._ctx.restore("translate");
  }
  _drawGrid() {
    let rsplit = 4 / this._circlecnt;
    // console.log(rsplit)
    this._ctx.strokeStyle = "gray";
    this._ctx.save("translate");
    this._ctx.translate(28, 0);
    this._ctx.lineWidth = 0.5;
    for (let id = 1; id <= this._circlecnt; id++) {
      this._ctx.beginPath();
      this._ctx.arc(-70, 0, rsplit * id * this._scale, 0, Math.PI * 2);
      this._ctx.stroke();
    }
    this._ctx.restore("translate");
  }
  _drawCicleTick() {
    let w = this._measureText("").width;
    this._ctx.save("translate");
    this._ctx.translate(-42, 0); // 可以整体拖拽图形水平移动
    this._ctx.rotate(0.5 * Math.PI);
    this._ctx.font = "18px Arial";
    this._ctx.fillStyle = "white";
    this._ctx.strokeStyle = this._color === "white" ? "black" : "white";
    this._ctx.lineWidth = 0.5;
    for (let id = 0; id < 360; id += 22.5) {
      this._ctx.beginPath();
      if (parseInt(id * 10) % 450 === 0) {
        w = this._measureText(id + "°").width;
        this._ctx.fillText(id + "°", -w / 2, -this._circle.r - 8);
        this._ctx.fillStyle = "black";
      }
      this._ctx.moveTo(0, -this._circle.r);
      this._ctx.lineTo(0, -this._circle.r);
      // 大圆的分割线置灰
      this._ctx.strokeStyle = "gray";
      this._ctx.stroke();
      this._ctx.moveTo(0, 0);
      this._ctx.lineTo(0, -this._circle.r);
      this._ctx.stroke();
      this._ctx.rotate((-22.5 * Math.PI) / 180);
    }
    this._ctx.restore("translate");
    this._drawGrid();
  }
  DrawColorBar(axisX, axisY, tolTime) {
    this.tolTime = tolTime;

    this._ctx.clearRect(0, 0, this._ctx.width, this._ctx.height);
    let x = -1.5;
    let axisyfont = axisY;
    for (let i = 0; i < 15; i++) {
      axisyfont += 13;
      x += 1.5;
      this._ctx.fillStyle = "black";
      if (x === 0) {
        this._ctx.fillText(`0(s)`, axisX + 36, axisyfont + 10);
      }
      this._ctx.fillText(x, axisX + 36, axisyfont + 10);
    }
    for (let j = 1; j < 15; j++) {
      axisY += 13;
      this._ctx.fillStyle = this.colorBar[j === 0 ? j + 1 : j];
      this.drawRect(axisX, axisY);
    }
    this._ctx.fillStyle = "black";
    this._ctx.fillText(`>${tolTime}`, axisX + 36, axisY + 42);
    this._ctx.fillStyle = "white";
    this._ctx.strokeStyle = "gray"; // 白色边框的矩形
    this.drawRect(axisX, axisY + 30);
  }
  drawRect(x, y) {
    this._ctx.translate(0, 0);
    this._ctx.lineWidth = 1;
    this._ctx.strokeRect(x, y, 30, 23);
    this._ctx.fillRect(x, y, 30, 23);
  }
}
export default NibutMapDraw;



// WEBPACK FOOTER //
// ./src/dryeye/js/reportmapdrawForBut.js